import { calculateGapSize, DONUT_CENTER } from './utils/donut';

const HIGHLIGHT_RADIUS = 18.5;
const HIGHLIGHT_CIRCUMFERENCE = 2 * Math.PI * HIGHLIGHT_RADIUS;
const HIGHLIGHT_STROKE_WIDTH = 0.8;

type Props = {
  percentage: number;
  offset: number;
  segmentGap: number;
  color?: string;
  isFirst: boolean;
};

export function HighlightRing({
  percentage,
  offset,
  segmentGap,
  color,
  isFirst,
}: Props) {
  const gapSize = calculateGapSize(percentage, segmentGap);
  const rawArcLength = ((percentage - gapSize) * HIGHLIGHT_CIRCUMFERENCE) / 100;
  const arcLength = Math.max(0, rawArcLength - HIGHLIGHT_STROKE_WIDTH);
  const gapLength = HIGHLIGHT_CIRCUMFERENCE - arcLength;
  const capOffset =
    (HIGHLIGHT_STROKE_WIDTH / 2 / HIGHLIGHT_CIRCUMFERENCE) * 360;
  const baseRotation = isFirst ? 0 : offset * 3.6;
  const rotate = `rotate(${baseRotation + capOffset}, ${DONUT_CENTER}, ${DONUT_CENTER})`;

  return (
    <circle
      cx={DONUT_CENTER}
      cy={DONUT_CENTER}
      r={HIGHLIGHT_RADIUS}
      fill={'transparent'}
      stroke={color}
      strokeWidth={HIGHLIGHT_STROKE_WIDTH}
      strokeLinecap={'round'}
      strokeDasharray={`${arcLength} ${gapLength}`}
      transform={rotate}
      style={{ pointerEvents: 'none' }}
    />
  );
}
